import cx from 'classnames';
import styles from './PeriodSelector.module.scss';

const Periods = [
  { id: 'weekly', displayName: '1W' },
  { id: 'four-weekly', displayName: '4W' },
  { id: 'quarterly', displayName: '3M' },
  { id: 'semi-yearly', displayName: '6M' },
  { id: 'yearly', displayName: '1Y' },
];

interface PeriodSelectorProps {
  handleClickPeriod: (period: string) => void;
  selectedPeriod: string;
  disableChangeTypeOfPeriod: boolean;
}

const PeriodSelector = ({
  handleClickPeriod,
  selectedPeriod,
  disableChangeTypeOfPeriod,
}: PeriodSelectorProps): JSX.Element => {
  return (
    <div className={styles.periodSelector}>
      {Periods.map((period) => (
        <button
          className={cx(styles.periodButton, {
            [styles.selected]: selectedPeriod === period.id,
            [`${styles.disabled}`]: disableChangeTypeOfPeriod,
          })}
          key={period.id}
          onClick={() => handleClickPeriod(period.id)}
          disabled={disableChangeTypeOfPeriod || selectedPeriod === period.id}
        >
          {period.displayName}
        </button>
      ))}
    </div>
  );
};

export default PeriodSelector;
